import { createModuleContext } from '@rebuild/utils/moduleContext';

const MODULE_NAME = 'flow_home_wrapper';

function buildBaseCtx() {
	return {
		getModuleBgMap: {},
		formattedMenus: (menus = []) => menus,
		formattedFlowMobMenus: (menus = []) => menus
	};
}

const { provide: provideCurrentContext, use: useCurrentContext } = createModuleContext(MODULE_NAME, buildBaseCtx);

export { provideCurrentContext, useCurrentContext };
